<template>
  <div v-if="orderInfo.isBaseOrder">
    <div class="order-list" ref="list">
      <OrderItemCard
        :index="index"
        :data="item"
        v-for="(item, index) in orderInfo.orderItems"
        :key="index"
      />
    </div>
    <div class="base-info-container">
      <div class="payamount font13 c:row-between-center">
        <span>订单金额：</span>
        <span>¥ {{ orderInfo.amount | filterPrice }}</span>
      </div>
      <div>
        <div class="mb8 c:row-between-center">
          <span>订单编号</span>
          <span>{{ orderInfo.orderNo }}</span>
        </div>
        <div class="mb8 c:row-between-center">
          <span>下单时间</span>
          <span>{{
            (orderInfo.submitTime || orderInfo.createdDate) | formatDateTime
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="ea-order-info">
    <div class="ea-info-list">
      <div class="ea-info-item c:row-between-center">
        <span class="ea-label">订单类型</span><span class="value">订金单</span>
      </div>
      <div class="ea-info-item c:row-between-center">
        <span class="ea-label">订单金额</span
        ><span class="value">¥{{ orderInfo.amount | filterPrice }}</span>
      </div>
      <div class="ea-info-item c:row-between-center">
        <span class="ea-label">订单编号</span
        ><span class="value">{{ orderInfo.orderNo }}</span>
      </div>
      <div class="ea-info-item c:row-between-center">
        <span class="ea-label">下单时间</span
        ><span class="value">{{
          (orderInfo.submitTime || orderInfo.createdDate) | formatDateTime
        }}</span>
      </div>
      <div class="ea-info-item c:row-between-center">
        <span class="ea-label">备注 (客人可见)</span
        ><span class="value">{{ orderInfo.remark }}</span>
      </div>
      <div class="ea-info-item c:row-between-center">
        <span class="ea-label">备注 (仅内部可见)</span
        ><span class="value">{{ orderInfo.innerRemark }}</span>
      </div>
    </div>
    <div class="split-line"></div>
    <div class="connect-detail">
      <div class="connect-detail-title">关联商品</div>
      <div class="order-list" ref="list">
        <OrderItemCard
          :index="index"
          :data="item"
          v-for="(item, index) in orderInfo.orderItems"
          :key="index"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrderItemCard from "../widgets/OrderItemCard.vue";
export default {
  name: "shareDetail",
  props: {
    orderInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    OrderItemCard,
  },
};
</script>

<style lang="less" scoped>
.ea-order-info {
  .ea-info-list {
    background-color: #fff;
    margin-top: 20/40rem;
    padding: 0 40/40rem;
    .ea-info-item {
      padding: 40/40rem 0;
      font-size: 26/40rem;
      border-bottom: 1px dashed #dadada;

      .ea-label {
        color: #666;
      }
      .value {
        color: #333;
      }
      &:nth-last-child(1) {
        border-bottom: none;
      }
    }
  }
}
.connect-detail {
  margin-top: 20/40rem;
  margin-bottom: 20/40rem;
  background-color: #fff;
  color: #666;
  font-size: 26/40rem;
  &-title {
    padding-top: 40/40rem;
    padding-left: 40/40rem;
  }
}
.order-list {
  padding: 0 1rem;
}
.base-info-container {
  padding: 0 1rem;
  font-size: 11px;
  color: #7d7d7d;
}
.mb8 {
  margin-bottom: 8/20rem;
}
.payamount {
  background: #fff;
  padding: 14/20rem 0;
  color: @text-color;
  font-weight: bolder;
  border-bottom: 1px solid @border-color;
  margin-bottom: 20/20rem;
}
.split-line {
  background-color: #f7f7f7;
  height: 10/20rem;
}
</style>
